<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog max-width="1000" v-model="$store.getters.selectedFullDialog" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    <!--Πληροφορίες-->
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="mt-5">
                    <v-tabs v-model="tab"
                            fixed-tabs>
                        <v-tab href="#tab-1">
                            Πληροφοριες
                        </v-tab>
                        <v-tab href="#tab-2" v-if="$store.getters.homePageInformation.type != 'Allocator'">
                            Σημεια Διανομης
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item
                                key="1"
                                value="tab-1">
                            <v-row>
                                <v-col lg="6" md="12" sm="12">
                                    <v-card class="elevation-6">
                                        <v-card-title>Μάθημα</v-card-title>
                                        <v-divider></v-divider>
                                        <v-row>
                                            <v-col>
                                                <v-list-item v-for="(courseInfo, n) in courseInformation" dense>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>{{courseInfo.label}}</v-list-item-subtitle>
                                                        <v-list-item-title v-if="courseInfo.value == 'year'">
                                                            {{selectedObj.course[courseInfo.value]}} -
                                                            {{Number(selectedObj.course[courseInfo.value]) + 1}}
                                                        </v-list-item-title>
                                                        <v-list-item-title v-else-if="courseInfo.value == 'period'">
                                                            {{getPeriod(selectedObj.course[courseInfo.value])}}
                                                        </v-list-item-title>
                                                        <v-list-item-title v-else>{{selectedObj.course[courseInfo.value]}}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                                <v-col lg="6" md="12" sm="12">
                                    <v-card class="elevation-6">
                                        <v-card-title>Γραμματεία</v-card-title>
                                        <v-divider></v-divider>
                                        <v-row>
                                            <v-col>
                                                <v-list-item v-for="(secreteriatInfoA, n) in secretariatInformationA" dense>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>{{secreteriatInfoA.label}}</v-list-item-subtitle>
                                                        <v-list-item-title>{{selectedObj.academic[secreteriatInfoA.value]}}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item v-for="(secreteriatInfoB, n) in secretariatInformationB" dense>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>{{secreteriatInfoB.label}}</v-list-item-subtitle>
                                                        <v-list-item-title>{{selectedObj.secretariat[secreteriatInfoB.value]}}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-col>
                                            <v-col>
                                                <v-list-item v-for="(secreteriatInfoC, n) in secretariatInformationC" dense>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle>{{secreteriatInfoC.label}}</v-list-item-subtitle>
                                                        <v-list-item-title>
                                                            {{selectedObj.currentAcademicYear[secreteriatInfoC.value1]}}
                                                            - {{selectedObj.currentAcademicYear[secreteriatInfoC.value2]}}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-card class="elevation-6">
                                <v-card-title>Βιβλίο</v-card-title>
                                <v-divider></v-divider>
                                <v-row>
                                    <v-col>
                                        <v-list-item v-for="(bookInfoA, n) in bookInformationA" dense>
                                            <v-list-item-content>
                                                <v-list-item-subtitle>{{bookInfoA.label}}</v-list-item-subtitle>
                                                <v-list-item-title>{{selectedObj.book[bookInfoA.value]}}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                    <v-col v-if="$store.getters.homePageInformation.type != 'Allocator'">
                                        <v-list-item v-for="(bookInfoB, n) in bookInformationB" dense>
                                            <v-list-item-content>
                                                <v-list-item-subtitle>{{bookInfoB.label}}</v-list-item-subtitle>
                                                <v-list-item-title>{{selectedObj.book[bookInfoB.value]}}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item
                                key="2"
                                value="tab-2">
                            <DistributionPointArray :academicYearSelect="academicYearSelect" :selectedObj="selectedObj"/>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
                </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DistributionPointArray from "./DistributionPointArray";
    export default {
        name: "SelectedFullDialog",
        components: {DistributionPointArray},
        data: () => ({
            tab: null,
            bookInformationA: [
                {label: 'Τίτλος', value: 'title'},
                {label: 'Υπότιτλος', value: 'subtitle'},
                {label: 'Κωδικός στον Εύδοξο', value: 'id'},
                {label: 'Συγγραφείς', value: 'authors'},
                {label: 'Αριθμός Έκδοσης', value: 'editionNumber'},
                {label: 'Έτος Τρέχουσας Έκδοσης', value: 'publicationYear'},
            ],
            bookInformationB: [
                {label: 'Τόμος', value: 'volumeNumber'},
                {label: 'Τίτλος Τόμου', value: 'volumeTitle'},
                {label: 'ISBN', value: 'isbn'},
                {label: 'Εκδόσεις', value: 'editorialHouse'},
                {label: 'Δέσιμο', value: 'binding'},
                {label: 'Διαστάσεις', value: 'dimensions'},
                {label: 'Σελίδες', value: 'pages'},
            ],
            secretariatInformationA: [
                {label: 'Ίδρυμα', value: 'institution'},
                {label: 'Σχολή', value: 'school'},
                {label: 'Τμήμα', value: 'department'},
            ],
            secretariatInformationB: [
                {label: 'Νομός', value: 'secretaryPrefectureName'},
                {label: 'Δήμος', value: 'secretaryCityName'},
                {label: 'Προθεσμία Δήλωσης', value: 'dimensions'},
            ],
            secretariatInformationC: [
                {label: 'Χειμερινό Εξάμηνο', value1: 'statementStartXimerino', value2: 'statementEndXimerino'},
                {label: 'Εαρινό Εξάμηνο', value1: 'statementStartEarino', value2: 'statementEndEarino'},
            ],
            courseInformation: [
                {label: 'Τίτλος', value: 'title'},
                {label: 'Διδάσκοντες', value: 'professor'},
                {label: 'Εξάμηνο', value: 'semester'},
                {label: 'Ακαδημαϊκό Έτος', value: 'year'},
                {label: 'Περίοδος', value: 'period'},
                {label: 'Σχόλιο', value: 'comment'},
            ]

        }),

        props: {
            selectedObj: Object,
            academicYearSelect: Object
        },

        methods: {

            closeDialog() {
                this.tab = 'tab-1';
                this.$store.commit('setSelectedFullDialog', false);
            },

            getPeriod(period) {

                if (period == 'Earino') {
                    return 'Εαρινό'
                }
                else if (period == 'Ximerino'){
                    return 'Χειμερινό'
                }
                else {
                    return 'Ετήσιο'
                }
            }
        }
    }
</script>

<style scoped>

</style>